import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router";

import { loginWithTokenByRedirectPortal } from "../../store/modules/auth/actions";

import Loading from "../../components/Loading";

import { Container } from "./styles";

function TourLeague() {
	const dispatch = useDispatch();
	const { idLeague } = useParams();
	const [paramsQuery] = useState(new URLSearchParams(useLocation().search));

	useEffect(() => {
		let token = paramsQuery.get("token");
		if (!!token && !!idLeague) {
			dispatch(
				loginWithTokenByRedirectPortal({
					token,
					redirect: `/carregando-portal/{token}/tour-liga/${idLeague}`,
					redirectError: `/onboard/login-tour-liga/${idLeague}`,
				})
			);
		}
		// eslint-disable-next-line
	}, []);

	return (
		<Container>
			<Loading color="#FFF" />
		</Container>
	);
}

export default TourLeague;
